export function INIT_SEARCH_AGAIN(searchAgainButton) {
    const SEARCH_CONTENT_INPUT = document.getElementById('searchContent');
    searchAgainButton.addEventListener('click', () => {
        SEARCH_CONTENT_INPUT.focus();
    });
}
